const ErrorPage = () => import('@/views/ErrorPage.vue')
const NotFound = () => import('@/views/error/NotFound.vue')
const Forbidden = () => import('@/views/error/ForbiddenRequest.vue')
const BadRequest = () => import('@/views/error/BadRequest.vue')

export default [
  {
    path: '/blad',
    component: ErrorPage,
    children: [
      {
        path: '403',
        name: 'Forbidden',
        component: Forbidden,
        meta: {
          title: 'Błąd 403',
          metaTags: [{ name: 'robots', content: 'noindex' }]
        }
      }
    ]
  },
  {
    path: '/blad',
    component: ErrorPage,
    children: [
      {
        path: '400',
        component: BadRequest,
        name: 'BadRequest',
        meta: {
          title: 'Błąd 400',
          metaTags: [{ name: 'robots', content: 'noindex' }]
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: ErrorPage,
    children: [
      {
        path: '',
        name: 'NotFound',
        component: NotFound,
        meta: {
          title: 'Błąd 404',
          metaTags: [{ name: 'robots', content: 'noindex' }]
        }
      }
    ]
  }
]
